import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import qs from 'qs';
import { isArray } from 'lodash';
// import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { casesRoute } from '../../routes';
import baseUrl from '../../utils/baseUrl';

import connect from '../../utils/connect';
import Spinner from '../svg/spinner';

import CaseEditForm from './caseCreate/caseEditForm';
import ContentBlock from './block/content';
import ConfirmDialog from '../form/confirm';
import InputSubmit from '../form/input/submit';


import { redirectToAccountIfNoProfile } from '../../utils/authorization';

class AccountCaseEdit extends Component {

	static propTypes = {
		dispatch: PropTypes.func.isRequired,
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			waiting: true,
			submitting: false,
			showMore: false,
			case: {},
			caseId: props.router.params.id || 0,
		};
	}

	componentWillMount() {
		let API_URL = baseUrl + `/api/account/projects/${this.state.caseId}/form`;
		axios.get(API_URL)
		.then((res) => {
			if (res.data) {
				const caseItem = res.data;
				caseItem.categories = (isArray(caseItem.categories) ? caseItem.categories : []).map((obj) => {
					return obj.id;
				});

				caseItem.credits = JSON.stringify(caseItem.profiles);

				this.mounted && this.setState({
					...this.state,
					waiting: false,
					case: caseItem,
				});
			}
		})
		.catch(() => {

		});
	}

	render() {
		const API_URL = `/api/account/projects/${this.state.caseId}/form`;

		if (this.state.waiting) {
			return this.renderWaiting();
		}

		return (
			<div className='account-cases'>
				<Helmet title='The FWA - Projects - Edit' />
				<CaseEditForm
					ref='form'
					path={API_URL}
					method='put'
					smallAside={false}
					case={this.state.case}
					onSubmit={(promise) => {
						promise
						.then(() => {
							this.setSubmitting(false);
						})
						.catch(() => {
							this.setSubmitting(false);
						});
					}}
					head={this.renderHeader()}
					dispatch={this.props.dispatch}
				/>
			</div>
		);
	}

	renderHeader() {
		return (
			<ContentBlock title={`Edit project: ${this.state.case.title || ''}`} sticky browser={this.props.browser}>
				<div className='account-block-content__content__buttons'>
					<ConfirmDialog ref='confirm' />
					<button className='button button--dark' onClick={(e) => this.submitPreview(e)}>Preview</button>
					<InputSubmit name='Update project' className='button' waiting={this.state.submitting} onClick={() => this.setSubmitting(true) } />
				</div>
			</ContentBlock>
		);
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	setSubmitting(val = false) {
		this.mounted && this.setState({
			...this.state,
			submitting: val,
		});
	}

	submitPreview(e) {
		e.preventDefault();
		e.stopPropagation();

		if (!(this.refs.form && this.refs.form.refs && this.refs.form.refs.form)) {
			return false;
		}

		this.refs.confirm
		.confirm('Saving preview...', false, false);

		const API_URL = `${baseUrl}/api/account/projects/${this.state.caseId}/preview`;
		axios.put(API_URL, qs.stringify({
			...this.refs.form.refs.form.serialize(),
			preview: 1,
		}))
		.then((res) => {
			this.refs.confirm
			.confirm('Preview is ready', 'Open preview', false, casesRoute(res.data.case.slug) + '?preview=' + res.data.case.previewHash)
			.then(() => {
				// if (res.data && res.data.case && res.data.case.slug && res.data.case.previewHash) {
				// 	window.open(casesRoute(res.data.case.slug) + '?preview=' + res.data.case.previewHash);
				// }
			})
			.catch(() => {});
		})
		.catch((res) => {
			let text = 'Generating preview failed';

			if (res.data) {
				if (res.data.message) {
					text = res.data.message;
				}

				if (res.data.errors) {
					let errors = res.data.errors;
					let errorKeys = Object.keys(errors);
					for (var i = 0; i < errorKeys.length; i++) {
						text += '\n' + errors[errorKeys[i]];
					}
				}
			}

			this.refs.confirm
			.confirm(text, false)
		});
	}
}

export default connect(AccountCaseEdit);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/caseEdit.js
 **/